<template>
  <div class="modal-content">
    <div>
      <button
        class="modal-close"
        type="button"
        @click="cancelCallback"
      >
        ×
      </button>

      <div
        class="modal-icon"
        :class="`modal-icon__${type}`"
      >
        <CircleAlert :size="60" />
      </div>

      <h3 class="modal-title">{{ title }}</h3>

      <p
        class="modal-text"
        v-html="text"
      />
    </div>

    <div class="modal-actions">
      <button
        class="modal-button modal-button--cancel"
        type="button"
        @click="cancelCallback"
      >
        {{ btnTextCancel }}
      </button>

      <button
        class="modal-button modal-button--confirm"
        type="button"
        @click="confirmCallback"
      >
        {{ btnTextConfirm }}
      </button>
    </div>
  </div>
</template>

<script>
import { CircleAlert } from 'lucide-vue'

export default {
  name: 'ConfirmModal',
  components: {
    CircleAlert
  },
  props: {
    type: {
      // warning, error, info
      type: String,
      default: 'info'
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    btnTextConfirm: {
      type: String,
      default: ''
    },
    btnTextCancel: {
      type: String,
      default: ''
    },
    cancelCallback: {
      type: Function,
      default: () => {}
    },
    confirmCallback: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" src="./style.scss" />
